import { IconButton } from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import { FC } from "react";
import { useNotify, useRefresh } from "react-admin";

import ConfirmationPopover from "../../../components/ConfirmationPopover";
import Loader from "../../../components/Loader";
import TooltipPopover from "../../../components/TooltipPopover";
import { DocReference } from "../../../types/firebase.types";
import { applyUpdateTimestamp } from "../../../utils/timestamp";
import useCanUpdateBrandCategory from "../utils/useCanUpdateBrandCategory";

const DeleteBrandCategory: FC<any> = (props) => {
  const refresh = useRefresh();
  const notify = useNotify();

  const { canUpdateCategory, loading } = useCanUpdateBrandCategory(props.record.id);

  const handleDelete = async (ref: DocReference) => {
    try {
      await ref.update(
        applyUpdateTimestamp({
          deleted: true,
        })
      );
      refresh();
      notify("Brand category has been deleted", "success");
    } catch (ex: any) {
      console.log(ex.message);
      notify("Category might be is use, make sure to remove all related brands", "error");
    }
  };

  return (
    <TooltipPopover
      message={!canUpdateCategory ? "This category can't be deleted, some products belong to it!" : undefined}
    >
      <Loader loading={loading}>
        <ConfirmationPopover
          onConfirm={() => handleDelete(props.record.ref)}
          message="Are you sure you want to delete brand category?"
          confirmationText="Confirm"
          confirmationColor="secondary"
          disabled={!canUpdateCategory}
          Icon={
            <IconButton>
              <DeleteIcon color="error" />
            </IconButton>
          }
        />
      </Loader>
    </TooltipPopover>
  );
};

export default DeleteBrandCategory;
